import { SmallText } from 'hui';
import PropTypes from 'prop-types';
import qs from 'query-string';
import React from 'react';
import styled from 'styled-components';

const PaginationContainer = styled.div`
  display: flex;
  width: 200px;
  margin: 0 auto;
  justify-content: space-evenly;
`;

const Pagination: React.FC<{ previousHref?: string; nextHref?: string; params?: any }> = ({
  previousHref,
  nextHref,
  params
}) => {
  const search = qs.stringify(params);
  const searchString = !Object.keys(search).length ? '' : `?${search}`;

  const prevData = previousHref
    ? {
        color: 'primary',
        href: previousHref + searchString,
        as: 'a'
      }
    : {
        color: 'tint2',
        as: 'span'
      };
  const nextData = nextHref
    ? {
        color: 'primary',
        href: nextHref + searchString,
        as: 'a'
      }
    : {
        color: 'tint2',
        as: 'span'
      };

  return (
    <PaginationContainer>
      <SmallText {...prevData}>Previous</SmallText>
      <SmallText {...nextData}>Next</SmallText>
    </PaginationContainer>
  );
};

Pagination.propTypes = {
  previousHref: PropTypes.string,
  nextHref: PropTypes.string,
  params: PropTypes.object
};
export default Pagination;
